import PhraseParentheses from "../PhraseParentheses";
import { tagInfo } from "../constants";

const AdvancedGroupElement = ({
  currentPage,
  element,
  elementIndex,
  handleClickGroup,
  lineHeight,
}) => {
  return (
    <div
      key={"group_" + elementIndex}
      style={{
        position: "relative",
        display: "flex",
      }}
    >
      <div
        style={{
          display: "flex",
          transition: "background-color 0.5s ease",
          cursor: "pointer",
          flexWrap: "wrap", // 줄바꿈을 허용
        }}
        onClick={() => handleClickGroup(element, elementIndex)}
      >
        {element.text.map((text) => {
          return (
            <div
              style={{
                display: "flex",
                position: "relative",
                flexWrap: "wrap",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                marginTop: "20px",
                marginBottom: `calc(${lineHeight} - 20px)`,
                backgroundColor: "#EBEBEB",
              }}
            >
              {currentPage.groupData[text.index] && (
                <div
                  style={{
                    position: "absolute",
                    height: "42px",
                    top: "0px",
                    width:
                      currentPage.groupData[text.index].isGroupEnd &&
                      currentPage.groupData[text.index].space_right > 0
                        ? "calc(100% - 5px)"
                        : "100%",
                    borderBottom:
                      "1px solid " +
                      tagInfo[currentPage.groupData[text.index].groupType]
                        .color,
                  }}
                ></div>
              )}
              {currentPage.groupData[text.index] &&
                currentPage.groupData[text.index].isGroupLabel && (
                  <div
                    style={{
                      position: "absolute",
                      top: "39px",
                      left: "50%",
                      transform: "translateX(-50%)", // 수평 중앙 정렬
                      fontSize: "16px",
                      color:
                        tagInfo[currentPage.groupData[text.index].groupType]
                          .color,
                    }}
                  >
                    {tagInfo[currentPage.groupData[text.index].groupType].text}
                  </div>
                )}
              {currentPage.phraseData[text.index]?.start.map((phrase) => (
                <PhraseParentheses
                  phrase={phrase}
                  isStart={true}
                  inGroup={true}
                />
              ))}
              <span>{text.text}</span>

              {currentPage.phraseData[text.index]?.end.map((phrase) => (
                <PhraseParentheses
                  phrase={phrase}
                  isStart={false}
                  inGroup={true}
                />
              ))}
              <span>{text.space_right > 0 && " "}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdvancedGroupElement;
